function Headersearchpopupclose() {
    $("html").removeClass('nav-search-open');
    $(".nav-main-search-trigger").removeClass('nav-main-item-active');
    $(".body-content").removeAttr("aria-hidden");
    $("#footer").removeAttr("aria-hidden");
    $("body > .body-wrapper > .component").removeAttr("aria-hidden");

    if (lastFocusableHeaderElement)
        $(lastFocusableHeaderElement).off("keydown");

    $("#lefttxtSearch").val('');
}

function HeaderSearchAction() {
    var searchText = document.getElementById("txtSearch").value;
    var searchUrl = document.getElementById("txtSearch").getAttribute("data-targeturl");
    var searchTextLeft = ((document.getElementById("lefttxtSearch")) == null) ? '' : (document.getElementById("lefttxtSearch").value);
    var searchUrlLeft = ((document.getElementById("lefttxtSearch")) == null) ? '' : (document.getElementById("lefttxtSearch").getAttribute("data-targeturl"));
    if (searchText == "" && searchTextLeft == "") {
        return false;
    }
    else {
        if (searchText != "") {
            location.href = window.encodeURI(sanitizeHtmlStrings(decodeURI(searchUrl + "#q=" + searchText)));
        }
        else if (searchTextLeft != "") {
            location.href = window.encodeURI(sanitizeHtmlStrings(decodeURI(searchUrl + "#q=" + searchTextLeft)));
            document.getElementById("lefttxtSearch").value = '';
        }
        else {
            return false;
        }
    }

    Headersearchpopupclose();
}

function FooterSearchAction() {
    var searchText = document.getElementById("footerTextSearch").value;
    var searchUrl = document.getElementById("footerTextSearch").getAttribute("data-targeturl");
    if (searchText == "") {
        return false;
    }
    location.href = window.encodeURI(sanitizeHtmlStrings(decodeURI(searchUrl + "#q=" + searchText)));
    document.getElementsByClassName("custom-footer-autocomplete")[0].style.display = "none";
}

(function ($) {
    $(document).ready(function () {
        $(".left-nav-searchBox").children('.component').children('#txtSearch').attr("id", "lefttxtSearch");

        if ($('#txtSearch').length) {
            $('.nav-main-search.search-box').addClass('custom-coveo-search-new');
        }
        $("#txtSearch").keydown(function (e) {
            if (e.keyCode === 13) {
                var searchText = document.getElementById("txtSearch").value;
                var searchUrl = document.getElementById("txtSearch").getAttribute("data-targeturl");
                if (searchText == "") {
                    return false;
                }
                //location.href = searchUrl + "#q=" + searchText;
                location.href = window.encodeURI(sanitizeHtmlStrings(decodeURI(searchUrl + "#q=" + searchText)));
                Headersearchpopupclose();
            }
        });

        $("#lefttxtSearch").on('keydown', function (e) {
            if (e.keyCode === 13) {
                var searchText = document.getElementById("lefttxtSearch").value;
                var searchUrl = document.getElementById("lefttxtSearch").getAttribute("data-targeturl");
                if (searchText == "") {
                    return false;
                }
                location.href = window.encodeURI(sanitizeHtmlStrings(decodeURI(searchUrl + "#q=" + searchText)));
                Headersearchpopupclose();
            }
        });
    });
}(window.jQuery));

(function ($) {
    $(document).ready(function () {
        $('.footer-search-social .search-bar-footer-container .search-button').attr('tabindex', '0');
        $("#footerTextSearch").keydown(function (e) {
            if (e.keyCode === 13) {
                var searchText = document.getElementById("footerTextSearch").value;
                var searchUrl = document.getElementById("footerTextSearch").getAttribute("data-targeturl");
                if (searchText == "") {
                    return false;
                }
                location.href = window.encodeURI(sanitizeHtmlStrings(decodeURI(searchUrl + "#q=" + searchText)));
                document.getElementsByClassName("custom-footer-autocomplete")[0].style.display = "none";
            }
        });
        $(".footer-search-social .search-bar-footer-container .search-button").keydown(function (e) {
            if (e.keyCode === 13) {
                var searchText = document.getElementById("footerTextSearch").value;
                var searchUrl = document.getElementById("footerTextSearch").getAttribute("data-targeturl");
                if (searchText == "") {
                    return false;
                }
                location.href = window.encodeURI(sanitizeHtmlStrings(decodeURI(searchUrl + "#q=" + searchText)));
                document.getElementsByClassName("custom-footer-autocomplete")[0].style.display = "none";
            }
        });
    });
}(window.jQuery));

$(window).on("load", function () {
    function setCustomAutoComplete() {
        var headerinputattr = $("#txtSearch").attr('data-autocomplete');
        if (headerinputattr == "True") {
            $("#txtSearch").autocomplete({
                minLength: 3,
                source: function (request, response) {
                    $.ajax({
                        url: "/ssautocomplete",
                        type: 'POST',
                        data: {
                            language: document.getElementById("txtSearch").getAttribute("data-sitelang"),
                            searchTerm: request.term,
                            pagesize: document.getElementById("txtSearch").getAttribute("data-autosuggestioncount"),
                            isdps: document.getElementById("txtSearch").getAttribute("data-dps"),
                            iswildcard: document.getElementById("txtSearch").getAttribute("data-Wildcard")
                        },
                        success: function (data) {
                            if (data != null) {
                                response(data);
                            }
                            else {
                                response([]);
                            }
                        },
                        failure: function (msg) {
                            response([]);
                        }
                    });
                },
                classes: {
                    "ui-autocomplete": "custom-autocomplete"
                },
                select: function (event, ui) {
                    var searchUrl = document.getElementById("txtSearch").getAttribute("data-targeturl");
                    location.href = searchUrl + "#q=" + ui.item.value;
                    ui.item.value = '';
                    Headersearchpopupclose();
                }
            });
        }

        var footerinputattr = $("#footerTextSearch").attr('data-autocomplete');
        if (footerinputattr == "True") {
            $("#footerTextSearch").autocomplete({
                minLength: 3,
                source: function (request, response) {
                    $.ajax({
                        url: "/ssautocomplete",
                        type: 'POST',
                        data: {
                            language: document.getElementById("footerTextSearch").getAttribute("data-sitelang"),
                            searchTerm: request.term,
                            pagesize: document.getElementById("footerTextSearch").getAttribute("data-autosuggestioncount"),
                            isdps: document.getElementById("footerTextSearch").getAttribute("data-dps"),
                            iswildcard: document.getElementById("footerTextSearch").getAttribute("data-Wildcard")
                        },
                        success: function (data) {
                            if (data != null) {
                                response(data);
                            }
                            else {
                                response([]);
                            }
                        },
                        failure: function (msg) {
                            response([]);
                        }
                    });
                },
                classes: {
                    "ui-autocomplete": "custom-footer-autocomplete"
                },
                select: function (event, ui) {
                    var searchUrl = document.getElementById("footerTextSearch").getAttribute("data-targeturl");
                    location.href = searchUrl + "#q=" + ui.item.value;
                    ui.item.value = '';
                }
            });
        }
    }

    var jQueryUiLoading = false;
    var customAutoCompleteSet = false;

    function ensureJQueryUiAndAutocomplete() {
        if (customAutoCompleteSet) {
            return;
        }

        if (typeof jQuery.ui !== 'undefined') {
            setCustomAutoComplete();
            customAutoCompleteSet = true;
            return;
        }
        if (jQueryUiLoading) {
            return
        };
        jQueryUiLoading = true;
        var jQueryUiJs = document.createElement("script");
        jQueryUiJs.src = "/assets/vendor/jquery/jquery-ui.min.js";
        jQueryUiJs.onload = function () {
            setCustomAutoComplete();
        };
        document.body.appendChild(jQueryUiJs);
        customAutoCompleteSet = true;
    }

    if ($("#txtSearch").attr('data-autocomplete') === "True" ||
        $("#footerTextSearch").attr('data-autocomplete') === "True") {
        $("#txtSearch, #footerTextSearch").on('click change input', ensureJQueryUiAndAutocomplete);
    }

    // Target the search input
    var footerSearchInput = document.getElementById("footerTextSearch");

    // Clear the search input when the page is loaded or shown
    window.onpageshow = function () {
        // Clear the search text value
        if (footerSearchInput) {
            footerSearchInput.value = "";

            // Optional: Clear the value again after a brief delay
            setTimeout(function () {
                footerSearchInput.value = "";
            }, 100);
        }   // 100ms delay
    };
});

//brought from custom componenet
function initalLoadComplete() {
    if ($("header .nav-main-search .CoveoSearchbox .magic-box .magic-box-input input").length) {
        $("header .nav-main-search .CoveoSearchbox .magic-box .magic-box-input input").wrap("<form>").attr("type", "search").attr("id", "header-coveo-search");
        $("header .nav-main-search .CoveoSearchbox .magic-box .magic-box-input input").parent().attr("action", "/");
        $("header .nav-main-search .CoveoSearchbox .magic-box .magic-box-input input").attr("autocomplete", "off");
    }
}
$(window).on("load", initalLoadComplete);